export default __webpack_public_path__ + "static/media/LAS0240.34I-30564_-26210_0.f5924d1c.jpg";